import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../../redux/Auth/authActions';
import Button from '../Common/Button';
import Swal from 'sweetalert2';
import { validatePassword, validateUsername } from '../../validation';
import Logo from '../Logo';

function Registration({ username }) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const router = useRouter();
  const [btnLoader, setBtnLoader] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: username,
    },
  });

  useEffect(() => {
    const queryObj = router.query;
    console.log(router.query);
  }, []);
  // useEffect(() => {
  //   if (auth.isLogin) {
  //     router.push("/dashboard");
  //   }
  // }, [auth.isLogin, router]);
  useEffect(() => {
    if (auth.isLogin) {
      // router.push("/dashboard");
      router.push('/register-step1');
    }
  }, [auth.isLogin]);

  useEffect(() => {
    if (auth.error) {
      setBtnLoader(false);
      Swal.fire('Error!', auth.error, 'error');
    }
  }, [auth.error]);

  const onSubmit = (data) => {
    console.log(data);
    setBtnLoader(true);
    dispatch(
      registerUser({
        username: data.username,
        email: data.email,
        password: data.password,
      }),
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-3">
        <Logo />
      </div>
      <h1 className="h3 mb-3 fw-normal">Create an account for free</h1>
      <h5 className="fw-normal mb-5">Free forever. No payment needed.</h5>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon3">
          link.app/
        </span>
        <input
          type="text"
          className={`form-control ${errors?.username ? 'is-invalid' : ''}`}
          id="basic-url"
          aria-describedby="basic-addon3"
          placeholder="username"
          // maxLength={15}
          {...register('username', {
            required: 'Please enter username',
            ...validateUsername(),
          })}
        />
        {errors?.username && <div className="invalid-feedback">{errors.username.message}</div>}
      </div>

      <div className="form-floating mb-3">
        <input
          type="email"
          className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
          {...register('email', {
            required: 'Please enter email id',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'invalid email address',
            },
          })}
          placeholder="name@example.com"
        />
        <label htmlFor="floatingInput">Email address</label>
        {errors?.email && <div className="invalid-feedback">{errors.email.message}</div>}
      </div>

      <div className="form-floating mb-3">
        <input
          type="password"
          className={`form-control ${errors?.password ? 'is-invalid' : ''}`}
          {...register('password', {
            required: 'Please enter password',
            ...validatePassword(),
          })}
          placeholder="Password"
        />
        <label htmlFor="floatingPassword">Password</label>
        {errors?.password && <div className="invalid-feedback">{errors.password.message}</div>}
      </div>

      <Button className="w-100 btn-lg btn-primary" btntext="Sign up with email" loading={btnLoader} />
      <p className="fs-14 mt-2">
        By signing up, you agree to our{' '}
        <Link href="/terms-and-conditions">
          <a className="text-reset">Terms of Service</a>
        </Link>{' '}
        and{' '}
        <Link href="/privacy-policy">
          <a className="text-reset">Privacy Policy</a>
        </Link>
        .
      </p>
      <div className="text-center  text-muted mt-3">
        <Link href="/login">
          <a>Already have an account?</a>
        </Link>
      </div>
    </form>
  );
}

export default Registration;
